import React from 'react';

const Music: React.FC = () => {
  // YouTube Music playlist URL
  const playlistUrl = "https://music.youtube.com/playlist?list=PLUIuDHsYxpACvAD8JLYPDByzUXNXuPWXn";
  // Convert YouTube Music URL to YouTube embed URL
  const embedUrl = playlistUrl.replace('music.youtube.com/playlist', 'www.youtube.com/embed/videoseries');

  return (
    <section id="music" className="py-20 bg-gradient-to-b from-gray-900 to-black text-white" style={{backgroundColor: '#000', backgroundImage: 'linear-gradient(to bottom, #0a1930, #000)'}}>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Our Music</h2>
          <div className="h-1 w-20 bg-blue-500 mx-auto"></div>
          <p className="mt-6 text-xl text-gray-300 max-w-3xl mx-auto">
            Check out our official ShourKrish Band playlist
          </p>
        </div>

        <div className="mb-16">
          <div className="bg-gray-800 rounded-lg overflow-hidden shadow-lg p-4">
            <h3 className="text-2xl font-bold mb-4 text-blue-300 text-center">ShourKrish Band Playlist</h3>
            <div className="relative w-full overflow-hidden rounded-lg aspect-video">
              <iframe
                className="absolute inset-0 h-full w-full"
                src={`${embedUrl}`}
                title="ShourKrish Band Playlist"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <a 
                href={playlistUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-full text-sm font-medium transition-colors duration-300"
              >
                Open in YouTube Music
              </a>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default Music;
